<template>
  <div>
    <b-card-group deck>
      <b-card title="Informações:" header-tag="header" footer-tag="footer">
        <template #header>
          <div>
            <h6 class="mb-0">Nome:{{ oportunidade.nome }}</h6>
          </div>
        </template>

        <b-container class="mb-3 border-bottom">
          <b-row class="mb-3">
            <b-col sm="12" cols="12" class="d-flex">
              <img
                v-if="oportunidade.imagem"
                :src="oportunidade.imagem.image_file"
                class="d-block img-fluid mr-2"
                width="250"
                height="150"
              />
              <span class="valor"> {{ oportunidade.nome }}</span>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mb-3 border-bottom">
          <b-row class="mb-3">
            <b-col sm="12" cols="12" class="d-flex flex-column">
              <span class="label">Objeto: </span>
              <span class="valor" v-html="oportunidade.objeto" />
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mb-3 border-bottom border-custom">
          <b-row class="mb-3">
            <b-col sm="3" cols="12" class="d-flex flex-column"
              ><span class="label">Data inicial proposta: </span>
              <span class="valor">
                {{ oportunidade.data_proposta_ini | format_date }}
              </span>
            </b-col>
            <b-col sm="3" cols="12" class="d-flex flex-column">
              <span class="label">Data final proposta: </span>
              <span class="valor">
                {{ oportunidade.data_proposta_fim | format_date }}
              </span>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="mb-3 d-none">
          <b-row>
            <b-col sm="4" cols="12" class="d-flex flex-column"
              ><span class="label">Qualificação: </span>
              <span class="valor">{{
                oportunidade.qualificacao_propostas?.join()
              }}</span></b-col
            >
            <b-col sm="4" cols="12" class="d-flex flex-column"
              ><span class="label">Categoria: </span>
              <span class="valor">{{ oportunidade.categorias }}</span></b-col
            >
          </b-row>
        </b-container>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
export default {
  props: {
    oportunidade: {
      required: true,
    },
  },
};
</script>

<style>
.label {
  font-size: 11px;
  font-weight: bold;
}
.valor {
  font-size: 14px;
}

.label-link {
  font-size: 14px;
  margin-left: 6px;
  cursor: pointer;
  text-align: right;
  transition: all 0.5s;
}

.label-link:hover {
  color: #215373;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
